import script from "./TypographyHint.vue?vue&type=script&setup=true&lang=js"
export * from "./TypographyHint.vue?vue&type=script&setup=true&lang=js"

import "./TypographyHint.vue?vue&type=style&index=0&id=203c8be8&lang=scss"

const __exports__ = script;

export default __exports__